import React from 'react';
import { Datagrid, List, TextField, FunctionField } from 'react-admin';
import { CustomPagination } from '../../components/CustomPagination';
import { FilterList, ListActions } from '../../components/index';
import { Chip } from '@material-ui/core';

const RolesField = ({ record }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {record?.roles?.map((role, index) => (
        <Chip key={index} label={role} size="small" />
      ))}
    </div>
  );
};

export const UsersList = (props) => {
  return (
    <List
      {...props}
      actions={<ListActions />}
      perPage={100}
      pagination={<CustomPagination rowsPerPageOptions={[25, 50, 100, 250, 500]} />}
      filters={<FilterList />}>
      <Datagrid rowClick="edit">
        <TextField source="email" />
        <TextField source="name" />
        <FunctionField label="Roles" render={record => <RolesField record={record} />} />
        <TextField source="id" />
        <FunctionField
          label="Created"
          render={record => new Date(record.created).toLocaleString()}
        />
        <FunctionField
          label="Updated"
          render={record => new Date(record.updated).toLocaleString()}
        />
      </Datagrid>
    </List>
  );
};

